import { IRoute } from "src/pages/Router/routes";

import HelpPage from "./HelpPage";

export const HelpSection: IRoute[] = [
  {
    exact: true,
    path: "/support",
    pageComponent: HelpPage,
    title: "Help",
    roles: [ "customer" ],
    modules: [ "support" ],
    menuType: "MAIN",
    hidden: true,
    privateRoute: true
  },
  {
    exact: true,
    path: "/support",
    pageComponent: HelpPage,
    title: "Help",
    roles: [ "admin" ],
    modules: [ "support" ],
    menuType: "ADMIN_MAIN",
    hidden: true,
    privateRoute: true
  }
];

export default HelpSection;
